import { uniqueId } from 'lodash-es';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    formType: {
      type: String,
      default: '',
    },
    customInnerClass: {
      type: String,
      default: '',
    },
    customOuterClass: {
      type: String,
      default: '',
    },
    privacyLink: {
      type: String,
      default: '',
    },
  },

  emits: ['onChinesePiplConsentChange'],

  data() {
    return {
      cbdtConsent: {
        id: uniqueId('piplConsent_cbdtConsent_'),
        name: 'cbdtConsent',
        label: this.$t(`Form.pipl.cbdtConsentCheckboxTitle.${this.formType}`).trim(),
        value: this.value.cbdt,
        type: 'checkbox',
      },
      privacyPolicyConsent: {
        id: uniqueId('piplConsent_privacyPolicyConsent_'),
        name: 'privacyPolicyConsent',
        label: this.$t(`Form.pipl.privacyPolicyConsentCheckboxTitle.${this.formType}`, {
          privacyLink: this.privacyLink,
        }).trim(),
        required: true,
        value: this.value.privacyPolicy,
        type: 'checkbox',
      },
      ageConsent: {
        id: uniqueId('piplConsent_ageConsent_'),
        name: 'ageConsent',
        label: this.$t(`Form.pipl.ageConsentCheckboxTitle.${this.formType}`).trim(),
        help: this.$t(`Form.pipl.ageConsentStatement.${this.formType}`).trim(),
        required: true,
        value: false,
        type: 'checkbox',
      },
      shouldDisplayCbdtCheckbox: getFeatureFlag(FEATURE_FLAG.DISPLAY_PIPL_CBDT_CONSENT_CHECKBOX),
      shouldDisplayPrivacyPolicyCheckbox:
        this.$t(`Form.pipl.privacyPolicyConsentCheckboxTitle.${this.formType}`).trim() !== '',
      shouldDisplayAgeConsentCheckbox: this.$t(`Form.pipl.ageConsentCheckboxTitle.${this.formType}`).trim() !== '',
    };
  },

  computed: {
    chinesePiplCheckboxes() {
      const checkboxes = this.checkboxesForCurrentFormType[this.formType] || [];

      return checkboxes.filter((item) => {
        switch (item.name) {
          case 'cbdtConsent':
            return this.shouldDisplayCbdtCheckbox;
          case 'privacyPolicyConsent':
            return this.shouldDisplayPrivacyPolicyCheckbox;
          case 'ageConsent':
            return this.shouldDisplayAgeConsentCheckbox;
        }
        return true;
      });
    },

    checkboxesForCurrentFormType() {
      return {
        accountCreation: [this.privacyPolicyConsent, this.cbdtConsent, this.ageConsent],
        boutiqueAppointment: [this.privacyPolicyConsent, this.cbdtConsent, this.ageConsent],
        contact: [this.privacyPolicyConsent, this.cbdtConsent, this.ageConsent],
        lightCheckout: [this.privacyPolicyConsent, this.cbdtConsent, this.ageConsent],
        newsletter: [this.privacyPolicyConsent, this.cbdtConsent, this.ageConsent],
        payment: [this.privacyPolicyConsent, this.ageConsent],
        personalInformation: [],
        gep: [this.privacyPolicyConsent, this.cbdtConsent],
        bis: [this.ageConsent],
      };
    },

    hasConsentedToChinesePipl() {
      return this.chinesePiplCheckboxes.reduce(
        (carry, checkbox) =>
          Object.hasOwn(checkbox, 'required') && checkbox.required ? carry && checkbox.value === true : carry && true,
        true,
      );
    },

    innerClass() {
      return this.customInnerClass || '';
    },

    outerClass() {
      return this.customOuterClass || '';
    },
  },

  watch: {
    hasConsentedToChinesePipl: {
      immediate: true,
      handler() {
        this.$emit('onChinesePiplConsentChange', {
          cbdt: this.cbdtConsent.value,
          hasConsentedToChinesePipl: this.hasConsentedToChinesePipl,
        });
      },
    },

    cbdtConsent: {
      deep: true,
      handler(checkbox) {
        if (checkbox.value !== null) {
          this.$emit('onChinesePiplConsentChange', {
            cbdt: this.cbdtConsent.value,
            hasConsentedToChinesePipl: this.hasConsentedToChinesePipl,
          });
        }
      },
    },
  },
};
